import { useEffect, useState } from "react";
import {
  OptionType,
  UserPreference,
  UserPreferenceKey,
  UserPreferences,
  defaultUserPrefrences,
  getTimeFormatOptions,
} from "./UserPreference";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import FormSkeleton from "../../sharedComponents/FormSkeleton";
import { Card, Select } from "@velocity-ehs/component-library";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useLocales } from "../../../hooks/useLocales";

type Props = {
  userPreferences: UserPreference[];
  isLoading?: boolean;
  onSave: (values: any) => void;
};

const UserPreferencesForm: React.FC<Props> = (props) => {
  const { t } = useTranslation();

  const featureFlags = useFlags();

  const [languages, setLanguages] = useState<OptionType[]>([]);

  const { control, reset, handleSubmit } = useForm<UserPreferences>({
    mode: "onBlur",
    defaultValues: defaultUserPrefrences,
  });

  const locales = useLocales(featureFlags.enableTranslationsAPI);

  useEffect(() => {
    setLanguages(locales);
  }, [locales, locales.length]);

  const getUserPreference = (userPrefs, options, key) => {
    const userPref = userPrefs.find((pref) => pref.key === key);
    return userPref
      ? options.find((opt) => opt.value === userPref.value)
      : null;
  };

  const convertPreferencesForForm = (userPrefs: UserPreference[]) => {
    const userPreferences = {} as UserPreferences;
    userPreferences[UserPreferenceKey.language] = getUserPreference(
      userPrefs,
      languages,
      UserPreferenceKey.language
    );
    userPreferences[UserPreferenceKey.timeFormat] = getUserPreference(
      userPrefs,
      getTimeFormatOptions(),
      UserPreferenceKey.timeFormat
    );
    return userPreferences;
  };

  useEffect(() => {
    if (props.userPreferences && languages.length > 0) {
      const formUserPrefs = convertPreferencesForForm(props.userPreferences);
      reset(formUserPrefs);
    }
    /* eslint-disable-next-line */
  }, [props.userPreferences, languages.length, reset]);

  const form = (
    <form id="modify-profile-form" onSubmit={handleSubmit(props.onSave)}>
      <Select
        control={control}
        name="language"
        label={t("userPreferences_preferred_language")}
        options={languages}
        required={false}
      />
      <Select
        control={control}
        name="timeFormat"
        label={t("userPreferences_time_format")}
        options={getTimeFormatOptions()}
        required={false}
      />
    </form>
  );

  return (
    <>
      <Card title={t("interface_preferences")}>
        {!props.isLoading ? form : <FormSkeleton rows={3} />}
      </Card>
    </>
  );
};
export default UserPreferencesForm;
